import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as JobActions from './jobs.actions';
import { Job } from './jobs.model';

export const JobFeatureKey = 'Jobs';

export interface State extends EntityState<Job> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> = createEntityAdapter<Job>({
    selectId: (model: Job) => `${model.jobid}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const JobReducer = createReducer(
    initialState,
    on(JobActions.addJob, (state, action) =>
        adapter.addOne(action.Job, state)
    ),
    on(JobActions.upsertJob, (state, action) =>
        adapter.upsertOne(action.Job, state)
    ),
    on(JobActions.addJobs, (state, action) =>
        adapter.addMany(action.Jobs, state)
    ),
    on(JobActions.upsertJobs, (state, action) =>
        adapter.upsertMany(action.Jobs, state)
    ),
    on(JobActions.updateJob, (state, action) =>
        adapter.updateOne(action.Job, state)
    ),
    on(JobActions.updateJobs, (state, action) =>
        adapter.updateMany(action.Jobs, state)
    ),
    on(JobActions.deleteJob, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(JobActions.deleteJobs, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(JobActions.loadJobs, (state, action) =>
        adapter.setAll(action.Jobs, state)
    ),
    on(JobActions.clearJobs, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return JobReducer(state, action);
}

export const selectJobState = createFeatureSelector<State>(
    JobFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectJobState);
